<template>
    <DatatablePageLayout>
        <template v-slot:actionButtons v-if="!isReadOnly">
            <button class="sk-btn sk-btn-primary rounded-lg" @click="handleCreate">
                {{ $t('apps.campaigns.form.createButton') }}
            </button>
        </template>
        <template v-slot:datatable>
            <emptyAlert v-if="styles.length === 0" :message="$t('apps.configurator.alert-empty.styles-text')"/>
            <DataTable
                v-else
                :config="datatableConfig"
                :elements="styles"
                :stripe="true"
                :draggable="false"
                :sst="true"
                :pagination="pagination"
                @action="handleAction"
            />
        </template>
    </DatatablePageLayout>
</template>

<script>

import { v4 as uuidv4 } from 'uuid';
import loader from "@/modules/Shared/Mixins/loader";
import DataTable from "@/modules/Shared/Components/table/SKDataTable.vue";
import DatatablePageLayout from "@/modules/Shared/Pages/DatatablePageLayout.vue";
import ConfiguratorVersionService from "@/modules/Apps/Services/Configurator/ConfiguratorVersionService";
import ConfiguratorStylesService from '@/modules/Apps/Services/Configurator/ConfiguratorStylesService'
import {userHasAdminRole} from "@/modules/Auth/Helpers/permissionsHelper";
import store from "@/modules/Shared/Store/store";
import emptyAlert from "@/modules/Shared/Components/alert/emptyAlert.vue";

export default {
    name: "VersionStyles",
    components: {emptyAlert, DataTable, DatatablePageLayout },
    mixins: [loader],
    data() {
        return {
            styleTemplates: [],
            styles: [],
            datatableConfig: [
                { 'field' : 'name', head : this.$t('apps.configurator.manage-item.name'), 'searchable' : false, 'sortable' : false},
                { 'field' : 'template_name', head : this.$t('apps.configurator.manage-item.type'), 'searchable' : false, 'sortable' : false},
                { 'field' : 'timeOfYear', head : this.$t('admin.interactive-maps.timeofyear'), 'searchable' : false, 'sortable' : false},
                { 'field' : 'actions', 'type': 'actions', head : this.$t("geofences.geofences-messages.actions"), 'searchable' : false, 'sortable' : false }
            ],
            pagination: {},
        }
    },
    async created() {
        await this.loadAndNotifyError(async () => {
            await this.getStyleTemplates()
            await this.getStyles()
        })
    },
    async beforeRouteEnter (to, from, next) {
        const version = await ConfiguratorVersionService.getVersion(to.params.versionUuid);
        await store.dispatch('setRouteElement', version)
        next()
    },
    computed: {
        isReadOnly() {
            return !userHasAdminRole()
        }
    },
    methods: {
        async getStyleTemplates() {
            const styleTemplatesResponse = await ConfiguratorStylesService.getTemplateList(this.$route.params.versionUuid)
            this.styleTemplates = styleTemplatesResponse.data
        },

        async getStyles() {
            const stylesResponse = await ConfiguratorStylesService.getStyleList(this.$route.params.versionUuid)
            this.styles = this.parseStyles(stylesResponse.data)
            this.pagination = {
                per_page: stylesResponse.per_page,
                total: stylesResponse.total
            }
        },

        parseStyles(styles) {
            return styles.map(style => ({
                ...style,
                template_name: this.styleTemplates.find(styleTemplate => styleTemplate.uuid === style.styles_template_uuid).name,
                actions: this.isReadOnly ? ['edit'] : ['edit', 'delete']
            }))
        },

        async handleAction(type, uuid){
            switch(type) {
                case 'edit':
                    await this.$router.push({
                        name: 'styleCreate',
                        params: {
                            uuid: this.$route.params.uuid,
                            versionUuid: this.$route.params.versionUuid,
                            styleUuid: uuid
                        }
                    })
                    break
                case 'delete':
                    await this.deleteStyle(uuid)
                    break
            }
        },

        async handleCreate() {
            await this.$router.push({
                name: 'styleCreate',
                params: {
                    uuid: this.$route.params.uuid,
                    versionUuid: this.$route.params.versionUuid,
                    styleUuid: uuidv4()
                }
            })
        },

        async deleteStyle(uuid) {
            await this.loadAndNotify(async () => {
                await ConfiguratorStylesService.deleteStyle(uuid)
                await this.getStyles()
            })
        }
    }
};
</script>
